import React from "react";
import { Link } from "react-router-dom";
import { FaBolt, FaCheckCircle, FaLaptopCode, FaAward } from "react-icons/fa";

const ActivityOverviewCard = () => {
  const highlights = [
    {
      icon: <FaLaptopCode />,
      title: "181+ Algorithms Solved",
      desc: "Daily problem solving across Arrays, Trees, DP & Graphs on LeetCode."
    },
    {
      icon: <FaCheckCircle />,
      title: "23 Development Repositories",
      desc: "Full-stack apps, microservices & enterprise SaaS tools on GitHub."
    },
    {
      icon: <FaAward />,
      title: "3 Springboard Badges",
      desc: "Recognized certifications & milestones in software engineering."
    }
  ];

  const focusSkills = ["Java Spring Boot", "React.js", "Node.js", "MongoDB", "REST APIs", "DSA"];

  return (
    <div className="activity-card overview-card">
      <div className="activity-card-header">
        <div className="activity-card-title-group">
          <span className="card-icon overview-icon">
            <FaBolt />
          </span>
          <h2 className="activity-card-title">⚡ Activity Overview</h2>
        </div>
        <span className="platform-tag overview-tag">Consistency</span>
      </div>

      <div className="overview-highlights">
        {highlights.map((item, idx) => (
          <div key={idx} className="overview-item">
            <div className="overview-item-icon">{item.icon}</div>
            <div className="overview-item-text">
              <h3 className="overview-item-title">{item.title}</h3>
              <p className="overview-item-desc">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="overview-tech-stack">
        <span className="tech-stack-label">Core Tech Focus:</span>
        <div className="tech-tags-list">
          {focusSkills.map((skill, idx) => (
            <span key={idx} className="tech-tag">
              {skill}
            </span>
          ))}
        </div>
      </div>

      <Link
        to="/projects"
        className="activity-card-btn"
        aria-label="Explore Praveen Kumar's Projects"
      >
        Explore Featured Projects →
      </Link>
    </div>
  );
};

export default ActivityOverviewCard;
